import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a62bc6799f1da0014870bfb_1784963373268_03a32aaf/lab51plus/src/app/about/page.tsx");
